<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <PageHead label='带教老师月度绩效计算' label2="绩效详细" url="/achievement/monthly/teachlist"></PageHead>
      <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
        <!--begin: Search Form -->
        <div class="m-form m-form--label-align-right">
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">管理单元：</label>
              </div>
              <div class="m-form__control">
                <el-select v-model="condition.section" filterable placeholder="全部">
                  <el-option label="全部" value=""></el-option>
                  <el-option v-for="item in managesecOptions" :key="item.DictItemID" :label="item.DictItemName" :value="item.DictItemID">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">绩效月份：</label>
              </div>
              <div class="m-form__control">
                <el-date-picker v-model="condition.grantmonth" type="month" placeholder="绩效月份" value-format="yyyy-MM">
                </el-date-picker>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">发放状态：</label>
              </div>
              <div class="m-form__control">
                <el-select v-model="condition.grantstatus" filterable placeholder="全部">
                  <el-option label="全部" value=""></el-option>
                  <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
        </div>
        <div style="clear: both;"></div>
        <div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;">
          <el-button type="primary" icon="el-icon-search" @click="LoadMoneyGrantDetail">查询</el-button>
          <ExportButton :url='exportUrl' buttonname="导出"></ExportButton>
        </div>
        <!--end: Search Form -->
        <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
          <!--begin: Datatable -->
          <div style="width: 100%;overflow: auto;">
            <div v-html="tabScore">
            </div>
          </div>
          <el-dialog width="40%" :title="edittitle" :visible.sync="editVisible">
            <el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed" :model="editform"
              ref="planform">
              <div class="m-portlet__body">
                <div class="form-group m-form__group row" style="padding-top: 0;padding-bottom: 0;border-bottom: 0;">
                  <label class="col-xl-3 col-form-label">奖金：</label>
                  <div class="col-xl-6">
                    <el-form-item prop="money" :rules="[{required: true, message: '奖金不能为空', trigger: 'blur'},{ type: 'number', message: '奖金必须为数字值'}]">
                      <el-input type="age" v-model.number="editform.money" placeholder="请输入奖金"></el-input>
                    </el-form-item>
                  </div>
                </div>
                <div class="form-group m-form__group row" style="padding-top: 20px;padding-bottom: 0;border-bottom: 0;">
                  <label class="col-xl-3 col-form-label">备注：</label>
                  <div class="col-xl-6">
                    <el-input type="age" v-model.number="editform.editinfo" placeholder="请输入备注"></el-input>
                  </div>
                </div>
                <div class="form-group m-form__group row" style="padding-top: 20px;padding-bottom: 0;border-bottom: 0;">
                  <label class="col-xl-3 col-form-label">附件：</label>
                  <div class="col-xl-6" style="padding-top: 8px;">
                    <el-upload class="upload-demo" ref="upload" :action='uploadUrl' :limit="1" :before-upload="beforeAvatarUpload"
                      :on-success="handleAvatarSuccess" :show-file-list="false">
                      <a style="color:#66b1ff;">[上传]</a>
                    </el-upload>
                    <div v-if="this.editform.editfile != ''">
                      <el-button @click="SeeFile()" type="text" size="medium">查看</el-button>
                    </div>
                  </div>
                </div>
                <div class="form-group m-form__group row">
                  <div class="col-xl-12 m--align-center">
                    <el-button type="success" icon="el-icon-s-order" @click="SaveMoneyGrantDetail()">保存</el-button>
                  </div>
                </div>
              </div>
            </el-form>
          </el-dialog>
          <el-dialog width="40%" :title="infotitle" :visible.sync="infoVisible">
            <el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed" :model="editform"
              ref="planform">
              <div class="m-portlet__body">
                <div class="form-group m-form__group row" style="padding-top: 20px;padding-bottom: 0;border-bottom: 0;">
                  <label class="col-xl-3 col-form-label">备注：</label>
                  <label class="col-xl-9 col-form-label" style="text-align: left;">
                    {{editinfo.remark}}
                  </label>
                </div>
                <div class="form-group m-form__group row" style="padding-top: 20px;padding-bottom: 0;border-bottom: 0;">
                  <label class="col-xl-3 col-form-label">附件：</label>
                  <label v-if="editinfo.editfile=='' || editinfo.editfile==null" class="col-xl-9 col-form-label" style="text-align: left;">
                    无
                  </label>
                  <label v-if="editinfo.editfile!='' && editinfo.editfile!=null" class="col-xl-9 col-form-label" style="text-align: left;">
                    <span @click="See(editinfo.editfile)" style="color: rgb(102, 177, 255);cursor: pointer;">查看</span>
                  </label>
                </div>
              </div>
            </el-form>
          </el-dialog>
          <!--end: Datatable -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'MonthlyTec',
    data() {
      return {
        condition: {
          token: '',
          granttype: '2',
          section: '',
          grantmonth: '',
          grantstatus: ''
        },
        editform: {
          mgid: '',
          tecid: '',
          money: 0,
          editinfo: '',
          editfile: ''
        },
        editinfo: {
          remark: '',
          editfile: ''
        },
        tabScore: '',
        secOptions: [],
        statusOptions: [{
          value: '1',
          label: '发'
        }, {
          value: '2',
          label: '不发'
        }],
        exportUrl: this.$utils.Url.zpgl + '/api/APIMoneyGrant/TeachOut',
        uploadUrl: this.$utils.Url.zpgl + '/api/APIMoneyGrant/UploadFile',
        loading: true,
        managesecOptions: [],
        edittitle: '绩效修改',
        infotitle: '绩效修改详细',
        editVisible: false,
        infoVisible: false
      }
    },
    created() {
      window.Change = this.Change
      window.Edit = this.Edit
      window.EditRecord = this.EditRecord
    },
    methods: {
      beforeAvatarUpload: function(file) {
        const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
        if (!isJPG) {
          this.$message.error('上传图片只能是 JPG/PNG 格式!')
        }
        return isJPG
      },
      handleAvatarSuccess: function(res) {
        if (res.Code === 0) {
          this.editform.editfile = res.Data
          this.$message({
            message: '上传成功',
            type: 'success'
          })
        } else {
          this.$message({
            message: res.Msg + '，' + res.Error,
            type: 'error'
          })
        }
      },
      LoadMoneyGrantDetail: function() {
        this.loading = true
        this.tabScore = ''
        this.$http.post(this.$utils.Url.zpgl + '/api/APIMoneyGrant/TeachMoneyGrantDetail', this.condition)
          .then(res => {
            if (res.data.Code === 0) {
              this.tabScore = res.data.Data
            } else {
              this.$message({
                message: res.data.Msg + '，' + res.data.Error,
                type: 'error'
              })
            }
            this.loading = false
          })
          .catch(err => {
            this.tabScore = ''
            console.log(err)
            this.$message({
              message: '查询失败',
              type: 'error'
            })
            this.loading = false
          })
      },
      Change: function(id, status, name, statusname, stuid) {
        var message = "确定变更 " + name + " 绩效奖金的发放状态为 " + statusname + " 吗？"
        this.$confirm(message, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true
          var args = {
            token: this.condition.token,
            id: id,
            stuid: stuid,
            status: status
          }
          this.$http.post(this.$utils.Url.zpgl + '/api/APIMoneyGrant/Change', args)
            .then(res => {
              console.log(res.data)
              if (res.data.Code === 0) {
                this.$message({
                  message: '变更成功',
                  type: 'success'
                })
                this.LoadMoneyGrantDetail()
              } else {
                this.$message({
                  message: res.data.Msg + '，' + res.data.Data,
                  type: 'error'
                })
              }
              this.loading = false
            })
            .catch(err => {
              console.log(err)
              this.$message({
                message: '变更失败',
                type: 'error'
              })
              this.loading = false
            })
        }).catch(() => {})
      },
      LoadMoneyGrant: function() {
        var args = {
          token: this.condition.token,
          id: this.mgid
        }
        var that = this
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIMoneyGrant/Info', args, function(data, model) {
          model.section = data.Data.GrantSec
          var GrantMonth = data.Data.GrantMonth
          var date = new Date(GrantMonth)
          var year = date.getFullYear()
          var month = date.getMonth() + 1
          model.grantmonth = year + '-' + month
          that.LoadMoneyGrantDetail()
        }, null, null, this.condition)
      },
      LoadManageSec: function() {
        var args = {
          token: this.condition.token,
          username: this.condition.username,
          rolelevel: this.condition.rolelevel
        }
        var that = this
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIDictItem/ManageSecionList', args, function(data) {
          that.managesecOptions = data.Data
          that.LoadMoneyGrant()
        }, null, null, null)
      },
      Edit: function(mgid, tecid, tecname, grantmonth) {
        this.editVisible = true
        this.editform.mgid = mgid
        this.editform.tecid = tecid
        this.editform.editfile = ''
        this.editform.editinfo = ''
        this.edittitle = tecname + ' ' + grantmonth + ' 绩效修改'
        var args = {
          token: this.condition.token,
          mgid: this.editform.mgid,
          tecid: this.editform.tecid
        }
        var that = this
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIMoneyGrant/GetTecMoneyGrantInfo', args, function(data) {
          if (data.Code == 0) {
            var res = JSON.parse(data.Data)
            that.editform.money = Number(res[0].Money)
          }
        }, null, null, null)
      },
      EditRecord: function(mgid, tecid, tecname, grantmonth) {
        this.infoVisible = true
        this.infotitle = tecname + ' ' + grantmonth + ' 绩效修改详细'
        var args = {
          token: this.condition.token,
          mgid: mgid,
          tecid: tecid
        }
        var that = this
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIMoneyGrant/GetTecMoneyGrantEditInfo', args, function(
          data) {
          if (data.Code == 0) {
            var res = JSON.parse(data.Data)
            that.editinfo.remark = res[0].EditInfo
            that.editinfo.editfile = res[0].EditFile
          }
        }, null, null, null)
      },
      SeeFile: function() {
        var url = this.$utils.Url.zpgl + '/file/' + this.editform.editfile
        window.open(url)
      },
      See: function(file) {
        var url = this.$utils.Url.zpgl + '/file/' + file
        window.open(url)
      },
      SaveMoneyGrantDetail: function() {
        var args = {
          token: this.condition.token,
          mgid: this.editform.mgid,
          tecid: this.editform.tecid,
          money: this.editform.money,
          editinfo: this.editform.editinfo,
          editfile: this.editform.editfile
        }
        var that = this
        this.$http.post(this.$utils.Url.zpgl + '/api/APIMoneyGrant/UpdateTecMoneyGrantDetail', args)
          .then(res => {
            if (res.data.Code === 0) {
              that.$message({
                message: '修改成功',
                type: 'success'
              })
              that.editVisible = false
              that.LoadMoneyGrant()
            } else {
              that.$message({
                message: res.data.Msg + '，' + res.data.Data,
                type: 'error'
              })
            }
            that.loading = false
          })
          .catch(err => {
            console.log(err)
            that.$message({
              message: '修改失败',
              type: 'error'
            })
            that.loading = false
          })
      }
    },
    mounted: function() {
      this.condition.token = sessionStorage.getItem('token')
      this.condition.rolelevel = sessionStorage.getItem('rolelevel')
      this.condition.userid = sessionStorage.getItem('userid')
      this.mgid = this.$route.params.id
      this.LoadManageSec()
    }
  }
</script>

<style scoped="scoped">
  @import '../../../assets/css/achievementinfo.css'
</style>
